import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import ChargePointAddScreen from '../ChargePoint/screens/ChargePointAddScreen';
import ChargePointDetailScreen from '../ChargePoint/screens/ChargePointDetailScreen';
import ChargeTransactionDetailScreen from '../ChargeTransaction/screens/ChargeTransactionDetailScreen';
import ChargeStationAddScreen from './screens/ChargeStationAddScreen';
import ChargeStationDetailScreen from './screens/ChargeStationDetailScreen';
import ChargeStationListScreen from './screens/ChargeStationListScreen';
import MaintainerTicketDetailScreen from 'features/Maintainer/MaintainerTicket/screens/MaintainerTicketDetailScreen';

function ChargeStation(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<ChargeStationListScreen />} />
          <Route path="add" element={<ChargeStationAddScreen />} />
          <Route path=":chargeStationId" element={<ChargeStationDetailScreen />} />
          <Route path=":chargeStationId/edit" element={<ChargeStationAddScreen />} />
          <Route
            path=":chargeStationId/point/:chargePointId"
            element={<ChargePointDetailScreen />}
          />
          <Route path=":chargeStationId/point/add" element={<ChargePointAddScreen />} />
          <Route
            path=":chargeStationId/point/:chargePointId/edit"
            element={<ChargePointAddScreen />}
          />
          <Route
            path=":chargeStationId/point/:chargePointId/transaction/:chargeTransactionId"
            element={<ChargeTransactionDetailScreen />}
          />
          <Route
            path=":chargeStationId/ticket/:ticketId"
            element={<MaintainerTicketDetailScreen />}
          />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default ChargeStation;
